module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I hated Steve Sayres the way you’d hate an ex-husband. And I’d spent almost as much as time with him. For six and a half years, we’d been two doors in a hallway, two stars in a too-small firmament.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And if I’d been the bigger star, well, he should have been glad. It was his partnership share of the law firm that I’d swollen. He’d taken home the extra money—bought the sailboat, the wine cellar, the lathed mahogany wainscot—not me. He’d been able to leave at seven because I, a hungry associate determined to “make partner,” could be trusted to toil fiercely till ten.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But his prosperity came at a price: I stood beside him in the mirror. And he was a pampered doctor’s son, star of the corny-movie football team. If he shared the sunshine, it was supposed to be with other golden boys on a happy shortcut. Not with a slap-in-the-face woman who wouldn’t cheerlead and wouldn’t pass the ball if she could run with it herself.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Even now, with me out of the firm and out of Sayres’ (expensive) neighborhood, even now, he could only begrudge me. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Worse, he couldn’t let it go, he couldn’t leave me alone. I’d tried to tell him: Yes, you won the pissing contest, Sayres. You can put it back in your pants now. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But I’d heard his slanderous spewings from a half dozen sources. And now my only cash-cow client was firing me because of him.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I tried not to leap from my chair with an angry, “Fine! Lose your case the good-old-boy way.” I tried to remember it might not be too late to pull this chestnut out of the fire.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I think you’d be making a mistake to go elsewhere, Perry. There’s an enormous learning curve in a case like this.” Though the intricacies of custom robotics had justified my retainer, it hadn’t been a fun study. “Why pay for someone else to become acquainted with the details of your operation. Plus,”—I spoke hastily, seeing he wanted to put an end to an embarrassing situation—“you won’t find a better-suited attorney. I have years of experience in corporate litigation.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Well …” He shifted his ample posterior in my just-upgraded chair. “You’ve taken on this criminal case.” His tone implied I’d jilted him for an unsuitable underling. “And as I said, with the in and outs of that …” He trailed off, as if there were no need to reprise his reasoning. As if he’d already explained.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’ve heard that I back-burner civil cases, haven’t you? That I concentrate on my criminal clients and short-change my corporate.” I forced myself to swallow Steve’s name. “It’s not true.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Perry, and the multi-million dollar business he represented, stood up, preparing to leave. “It’s just, you know, Laura. With so much money at stake …” His jaw tightened visibly. “The shareholders pay me to be cautious. You’re a one-person firm. And you now have this big criminal case.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I looked up at his well-fed, petulant face. He had the spoiled-husband air of a wealthy man in his fifties. He appeared unused to contradiction. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("How many times had his corporation been sued, I wondered. Often enough for him to realize the judge in his months-away-from-trial suit would allow me court days off to defend another case. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Be honest,” I urged. “Steve Sayres came to you, didn’t he? He told you I’d ignore you because of this other case.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But even as I said it, I knew it hadn’t happened quite that way. Steve was a master of the small needle, a jab here and a jab there, until the inflammation set in. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He’d have made a comment or two over drinks, another over lunch, a friendly hint, a sad shake of the head. Sayres was easy to see through, but most eyes stopped at the crinkly smile and gorgeous suit.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My client—former client now, I could see—frowned slightly, pursing his lips in dismissive distaste. I sometimes think our strongest cultural bias is against accusers. No matter the accusation, we suspect it of tacky paranoia, silly conspiracy theory, strident bad-sportsmanship. Maybe we hate to have to deal with other people’s problems. It’s easier to think ill of the afflicted.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I watched Perry and took stock. He would believe Sayres over me because Sayres had convinced him they were the same: good guys in business. He wouldn’t believe me because I fit a favorite stereotype: ballbreaker with a problem. I’d encountered this a thousand times in a thousand guises.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("One day, you accept the familiar injustice with your usual resignation. The next, you know you’ve had enough.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-124a0aa7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DesignerCrimes-2.vue
// module id = 72
// module chunks = 0